import { render } from "./EditContact.vue?vue&type=template&id=56b72bed"
import script from "./EditContact.vue?vue&type=script&lang=ts"
export * from "./EditContact.vue?vue&type=script&lang=ts"
script.render = render

export default script